import api from './api';

export const getControleMigracao = async () => {
  try {
    const response = await api.get('/controleMigracao');
    return response;
  } catch (error) {
    return { error };
  }
};

export const putControleMigracao = async payload => {
  try {
    const response = await api.put('/ControleMigracao', payload);
    return response;
  } catch (error) {
    return { error };
  }
};
